"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiFormHelperTextThemeOptions = void 0;
const material_1 = require("@mui/material");
exports.MuiFormHelperTextThemeOptions = {
    defaultProps: {},
    styleOverrides: {
        root: ({ ownerState = {}, theme }) => ({
            marginLeft: 0,
            ...(ownerState.error && {
                [`.${material_1.typographyClasses.root}`]: {
                    color: theme.palette.orange[80],
                },
                svg: {
                    color: theme.palette.orange[50],
                    marginRight: theme.spacing(1),
                },
            }),
        }),
    },
};
